import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class OrganizationService {
	readonly travelOrganizationGovernmentApproval = signal('');

	organizationData = this.clearOrganizationData();
	enterpriseData = this.clearEnterpriseData();
	pageTitle = '';

	pageTitleGenerate(): string {
		return `${this.organizationData.name} (ID: ${this.organizationData.id})`;
	}

	//TODO: Check interfaces
	clearOrganizationData(): any {
		return {
			id: null,
			shortName: null,
			name: null,
			sellCategory: null,
			codeMerlinx: '',
			agencyMerlinx: null,
			regon: null,
			nip: null,
			krs: null,
			nawigatorID: null,
			isOskar: false,
			isActive: false,
			address: [],
			departments: [],
			balance: null,
			kindCooperation: null,
		};
	}

	//TODO: Check interfaces
	clearEnterpriseData(): any {
		return {
			locations: [],
			organizationRoles: [],
			organizationDepartments: [],
			sellCategory: [],
			addressKind: [],
			bankAccounts: [],
			currency: [],
			departmentKinds: [],
			accountKind: [],
			users: [],
			departmentsForUsers: [],
			departmentUsers: [],
			mainAccount: [],
		};
	}

	resetData(): void {
		this.organizationData = this.clearOrganizationData();
		this.enterpriseData = this.clearEnterpriseData();
	}
}
